import { render, staticRenderFns } from "./EditTipologiaservizio.vue?vue&type=template&id=7678a12d&"
import script from "./EditTipologiaservizio.vue?vue&type=script&lang=ts&"
export * from "./EditTipologiaservizio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports